import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { sanitizeSources, sha256Hash } from './common/utils';

// New instrumentation attributes must be added to this function to be included in all the events
export var filterCommonAttributes = function filterCommonAttributes(props) {
  var appliedFilters = props.appliedFilters,
    answerFormat = props.answerFormat,
    answerLength = props.answerLength,
    answerCardType = props.answerCardType,
    followUps = props.followUps,
    sources = props.sources,
    extraAttributes = props.extraAttributes,
    searchSessionId = props.searchSessionId,
    queryHash = props.queryHash,
    query = props.query,
    answerString = props.answerString,
    apiSource = props.apiSource;
  return _objectSpread({
    searchSessionId: searchSessionId,
    queryHash: queryHash,
    wordCount: (query.match(/\w+/g) || []).length,
    queryLength: query.length,
    answerHash: sha256Hash(answerString),
    appliedFilters: appliedFilters,
    answerFormat: answerFormat,
    answerLength: answerLength,
    answerCardType: answerCardType,
    followUpsCount: followUps.length,
    followUpsLength: followUps.map(function (followUp) {
      return followUp.length;
    }),
    sources: sanitizeSources(sources),
    apiSource: apiSource
  }, extraAttributes);
};
export var onCuratedDefinitionUpdateButtonClicked = function onCuratedDefinitionUpdateButtonClicked(_ref) {
  var commonAttributes = _ref.commonAttributes,
    newDefinition = _ref.newDefinition,
    restrictedScope = _ref.restrictedScope,
    sourceSelected = _ref.sourceSelected,
    aiDefinitionEdited = _ref.aiDefinitionEdited;
  var keyPhrase = commonAttributes.query,
    oldDefinition = commonAttributes.answerString,
    extraAttributes = commonAttributes.extraAttributes,
    source = commonAttributes.source;
  return {
    action: 'clicked',
    actionSubject: 'aiCuratedDefinitionUpdateButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread(_objectSpread({}, extraAttributes), {}, {
      restrictedScope: restrictedScope,
      sourceSelected: sourceSelected,
      newDefinitionLength: newDefinition.length,
      // whether the user is editing an AI answer or already edited definition
      aiDefinitionEdited: aiDefinitionEdited
    }),
    nonPrivacySafeAttributes: {
      keyPhrase: keyPhrase,
      oldDefinition: oldDefinition,
      newDefinition: newDefinition
    }
  };
};
export var onCuratedDefinitionSeeEditHistoryButtonClicked = function onCuratedDefinitionSeeEditHistoryButtonClicked(props) {
  var query = props.query,
    answerString = props.answerString,
    extraAttributes = props.extraAttributes,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiCuratedDefinitionSeeEditHistoryButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, extraAttributes),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};
export var onLikeButtonClick = function onLikeButtonClick(props) {
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerLikeButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};
export var onDislikeButtonClick = function onDislikeButtonClick(props) {
  var query = props.query,
    answerString = props.answerString,
    source = props.source;
  return {
    action: 'clicked',
    actionSubject: 'aiAnswerDislikeButton',
    source: source,
    eventType: 'ui',
    attributes: _objectSpread({}, filterCommonAttributes(props)),
    nonPrivacySafeAttributes: {
      query: query,
      answerString: answerString
    }
  };
};